import { IBasketItem } from '@/shared/api/getBasket/types';
import Image from 'next/image';
import { FC, useState } from 'react';
import {
  cvaGroup,
  cvaGroupTitle,
  cvaGroupTitleGreenText,
  cvaItem,
  cvaItemImage,
  cvaItemImageWrap,
  cvaItems,
  cvaRoot,
  showMoreItems,
  showMoreItemsIcon,
  showMoreItemsText,
} from './PvzMapDetailsBodyStyles';
import IconCaretDown from '/public/icons/arrow-down.svg';
interface Props {
  pickupItems: IBasketItem[];
  date: string;
}

const PvzMapDetailsBody: FC<Props> = ({ pickupItems, date }) => {
  const [maxShowPickupItems, setMaxShowPickupItems] = useState<number>(4);

  const onClickShowMorePickupItems = () => {
    maxShowPickupItems < pickupItems.length ? setMaxShowPickupItems(pickupItems.length) : setMaxShowPickupItems(4);
  };

  return (
    <div className={cvaRoot()}>
      <div className={cvaGroup()}>
        <div className={cvaGroupTitle()}>
          Можно забрать <span className={cvaGroupTitleGreenText()}>{date}</span>
        </div>
        <div className={cvaItems()}>
          {[...pickupItems].splice(0, maxShowPickupItems).map((item, index) => (
            <div className={cvaItem()} key={index}>
              <div className={cvaItemImageWrap()}>
                {item.product.images && item.product.images.length ? (
                  <Image src={item.product.images[0]} className={cvaItemImage()} fill alt="" />
                ) : null}
              </div>
            </div>
          ))}
        </div>
        {pickupItems.length > 4 ? (
          <div className={showMoreItems()} onClick={() => onClickShowMorePickupItems()}>
            <span className={showMoreItemsText()}>{pickupItems.length} товаров</span>{' '}
            <IconCaretDown
              className={showMoreItemsIcon({
                active: maxShowPickupItems === pickupItems.length,
              })}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PvzMapDetailsBody;
